import styled from 'styled-components';

export const Section = styled.section`
  margin: 47px 0;
  display: flex;
  justify-content: center;

  .supplement-thumbs {
    flex: 1;
    max-width: 400px;
    width: 100%;

    > h2,
    > h3 {
      display: none;
    }

    img {
      max-width: 400px;
      width: 100%;
    }
  }

  .supplement-content {
    margin-left: 40px;
    flex: 1;

    /* h2 {
      font-size: 50px;
      line-height: 40px;
      color: var(--blue-water);
      font-weight: 800;
      text-transform: uppercase;
    }

    h3 {
      color: var(--grey-darker);
      text-transform: uppercase;
      font-size: 18px;
      line-height: 41px;
      margin-top: 18px;
    } */

    p {
      color: var(--grey-medium-darker);
      font-size: 16px;
      line-height: 34px;

      @media only screen and (max-width: 768px) {
        line-height: 24px;
      }
    }
  }

  .supplement-container-btn {
    max-width: 450px;
    width: 100%;
    margin: 20px 0;
  }

  .supplement-recommendations {
    margin: 40px 0;

    .supplement-info {
      margin: 20px 0;
    }
  }

  .supplement-more-info {
    strong {
      font-weight: 700;
      text-transform: uppercase;
      margin-right: 6px;
    }

    .nutricional_information {
      margin: 40px 0;
    }
  }

  @media only screen and (max-width: 800px) {
    flex-direction: column;
    .supplement-thumbs {
      max-width: 100%;
      width: initial;
      padding: 0 20px;

      img {
        max-width: 100%;
      }
      h2 {
        font-size: 38px;
      }
      h3 {
        margin-top: 0;
      }

      h2,
      h3 {
        display: block;
        display: flex;
        justify-content: center;
      }
    }

    .supplement-content {
      margin-left: 0;
      padding: 0 20px;
      > h2,
      > h3 {
        display: none;
      }
    }

    .supplement-container-btn {
      max-width: 100%;
      display: flex;
      justify-content: center;
    }
  }
`;

export const Title = styled.h2`
  font-size: 50px;
  line-height: 40px;
  color: var(--blue-medium);
  font-weight: 800;
  text-transform: uppercase;
`;

export const Description = styled.h3`
  color: var(--grey-darker);
  font-size: 18px;
  line-height: 41px;
  margin-top: 18px;
  &.subtitle{
    text-transform: uppercase;
  }
`;
